import type { Copy } from "../types";

export const gu: Copy = {
    seo: {
      title: "કાર ઉંમર કેલ્ક્યુલેટર | વર્ષ અને મહિના મુજબ વાહનની ઉંમર તપાસો",
      description:
        "ઉત્પાદન વર્ષ અને વૈકલ્પિક મહિનાથી વાહનની ચોક્કસ ઉંમર તપાસો. એક સરળ સાધનમાં વર્ષ, મહિના, દિવસ, કુલ દિવસો અને મહત્વપૂર્ણ પડાવ જુઓ.",
      keywords: [
        "કાર ઉંમર કેલ્ક્યુલેટર",
        "વાહન ઉંમર કેલ્ક્યુલેટર",
        "કાર ઉત્પાદન વર્ષ તપાસો",
        "વાહન ઉત્પાદન મહિનો તપાસો",
        "મારી કાર કેટલી જૂની છે",
        "વર્ષ મુજબ કાર ઉંમર",
        "વાહન ઉંમર તપાસો",
        "RC ઉંમર કેલ્ક્યુલેટર",
        "મહિના મુજબ કાર ઉંમર",
        "વાહન તારીખ કેલ્ક્યુલેટર",
        "mParivahan વિકલ્પ",
        "Parivahan વિકલ્પ",
        "RTO વાહન ઉંમર કેલ્ક્યુલેટર",
        "કાર રજિસ્ટ્રેશન ઉંમર",
        "વાહન રજિસ્ટ્રેશન ઉંમર",
      ],
      faq: [
        {
          question: "આ કેલ્ક્યુલેટર શું કરે છે?",
          answer:
            "તે પસંદ કરેલા ઉત્પાદન વર્ષ અને વૈકલ્પિક મહિનાથી વાહનની ચોક્કસ ઉંમર ગણતરી કરે છે અને વર્ષ, મહિના, દિવસ અને મહત્વપૂર્ણ પડાવ બતાવે છે.",
        },
        {
          question: "વૈકલ્પિક મહિનો શા માટે છે?",
          answer:
            "મહિનો ઉમેરવાથી ઉંમરની ગણતરી વધુ ચોક્કસ બને છે. જો તમે મહિનો ન પસંદ કરો તો પસંદ કરેલા વર્ષનો જાન્યુઆરી લેવામાં આવે છે.",
        },
        {
          question: "શું હું ભવિષ્યનું વર્ષ અથવા મહિનો પસંદ કરી શકું?",
          answer:
            "ના. ભવિષ્યના વર્ષો રોકાયેલા છે અને પસંદ કરેલું વર્ષ વર્તમાન વર્ષ હોય ત્યારે ભવિષ્યના મહિના પણ બંધ રહે છે.",
        },
      ],
    },
    headerTagline: "વાહન યુટિલિટી",
    headerTitle: "કાર ઉંમર કેલ્ક્યુલેટર",
    reset: "રીસેટ",
    switchToLight: "લાઇટ મોડ પર જાઓ",
    switchToDark: "ડાર્ક મોડ પર જાઓ",
    languageLabel: "ભાષા",
    languageEnglish: "અંગ્રેજી",
    languageHindi: "હિન્દી",
    heroEyebrow: "કારની ઉંમર, સ્પષ્ટ રીતે",
    heroTitle: "વાહનની ઉંમર જોવા માટેનું સ્વચ્છ તારીખ સાધન.",
    heroDescription: "ઉત્પાદન વર્ષ પસંદ કરો. વધુ ચોક્કસ પરિણામ માટે જ મહિનો ઉમેરો.",
    yearSelectLabel: "ઉત્પાદન વર્ષ",
    monthSelectLabel: "ઉત્પાદન મહિનો",
    includeMonthLabel: "વધુ ચોકસાઈ માટે ચોક્કસ મહિનો સામેલ કરો",
    includeMonthNote: "જો મહિનો સામેલ ન કરો તો ગણતરી માટે જાન્યુઆરી ઉપયોગમાં લેવાશે.",
    yearOnlyBadge: "ફક્ત વર્ષ",
    yearMonthBadge: "વર્ષ + મહિનો",
    yearPlaceholder: "વર્ષ પસંદ કરો",
    monthPlaceholder: "મહિનો પસંદ કરો",
    inputTitle: "ઉત્પાદન વર્ષ",
    inputLabel: "ઉત્પાદન વર્ષ",
    blockedDateNote: "ભવિષ્યના વર્ષો પસંદ કરી શકાતા નથી.",
    result: "પરિણામ",
    vehicleAgeLead: "તમારું વાહન",
    asOfToday: "આજની તારીખ પ્રમાણે",
    years: "વર્ષ",
    months: "મહિના",
    days: "દિવસ",
    totalDays: (count) => `કુલ ${count.toLocaleString("en-IN")} દિવસ`,
    ageLabels: { almostNew: "લગભગ નવું", modern: "આધુનિક", mature: "પરિપક્વ", classic: "ક્લાસિક" },
    estimatedValue: {
      high: "પુનર્વિક્રીની શક્યતા ઊંચી",
      healthy: "મૂલ્ય સારી રીતે ટકે છે",
      moderate: "મધ્યમ ઘટાડો",
      collector: "સંગ્રાહક રસ વધી શકે છે",
    },
    maintenanceTitle: "જાળવણી",
    maintenance: {
      routine: "નિયમિત સર્વિસ અને OEM કાળજી",
      watch: "બ્રેક, પ્રવાહી અને ટાયર પર નજર રાખો",
      plan: "ઘસાતાં ભાગો અને તપાસની યોજના બનાવો",
      specialized: "વિશેષ જાળવણી વધુ મહત્વપૂર્ણ બને છે",
    },
    registrationTitle: "નોંધણી",
    registration: {
      collector: "કેટલાક વિસ્તારોમાં સંગ્રાહક-શૈલીની છૂટ મળી શકે છે",
      classic: "કેટલાક વિસ્તારોમાં ક્લાસિક કાર નોંધણી લાગુ પડી શકે છે",
      standard: "સામાન્ય નવીનીકરણ અને પ્રાદેશિક તપાસની અપેક્ષા રાખો",
      regular: "સામાન્ય રીતે નિયમિત નોંધણી લાગુ પડે છે",
    },
    upcomingMilestoneTitle: "આગલો મહત્વપૂર્ણ પડાવ",
    milestoneTimelineTitle: "મહત્વપૂર્ણ પડાવ સમયરેખા",
    milestoneRemaining: ({ label, days }) => `${label} ${days.toLocaleString("gu-IN")} દિવસમાં`,
    reached: "પૂર્ણ",
    upcoming: "આવતું",
    allMilestonesReachedTitle: "બધા દર્શાવેલા મહત્વપૂર્ણ પડાવો પૂર્ણ થયા છે",
    allMilestonesReachedBody: "આ વાહને એપમાં બતાવેલી મહત્વપૂર્ણ પડાવની શ્રેણી પાર કરી છે.",
    copySummary: "સારાંશ નકલ કરો",
    shareResult: "પરિણામ શેર કરો",
    resetMessage: "કેલ્ક્યુલેટર રીસેટ થયું",
    summaryCopied: "સારાંશ ક્લિપબોર્ડમાં નકલ થયો",
    clipboardFailed: "ક્લિપબોર્ડ સુધી પહોંચવામાં નિષ્ફળતા",
    emptyTitle: "સંપૂર્ણ વિગતો જોવા ઉત્પાદન વર્ષ પસંદ કરો",
    emptyDescription:
      "વર્ષ પસંદ કરતા જ તમને ચોક્કસ ઉંમર, કુલ દિવસો, જાળવણી નોંધો, ક્લાસિક સ્થિતિ અને મહત્વપૂર્ણ પડાવનો સમય દેખાશે.",
    shareTitle: "કાર ઉંમર કેલ્ક્યુલેટર",
    summary: ({ label, years, months, days, asOf }) =>
      `મારી કાર ${label} માં બનાવાઈ હતી અને ${asOf} સુધી તેની ઉંમર ${years} વર્ષ ${months} મહિના ${days} દિવસ છે.`,
    milestones: {
      1: { label: "પ્રથમ વર્ષ", note: "વોરંટી અને સર્વિસ આયોજન માટે ઉપયોગી." },
      3: { label: "ત્રણ વર્ષ", note: "પુનર્વિક્રી અને કિંમત બદલાવ માટે સામાન્ય સમય." },
      5: { label: "પાંચ વર્ષ", note: "જાળવણી બજેટ ફરી જોવાનો સારો સમય." },
      10: { label: "દસ વર્ષ", note: "જૂના થતી ભાગો પર વધારે ધ્યાન આપો." },
      15: { label: "પંદર વર્ષ", note: "ઘણા વિસ્તારોમાં ક્લાસિક શૈલીની હેન્ડલિંગ શરૂ થાય છે." },
      25: { label: "પચ્ચીસ વર્ષ", note: "કેટલાક બજારોમાં સંગ્રાહક અને આયાત માટે આકર્ષક." },
    },
  };
